import { API_BASE_URL } from '@/config/env';

export const OIDC_CLIENT_ID = 'web';
export const OIDC_UI_LOCALES = 'lv';
export const OIDC_TOKEN_LEEWAY_SECONDS = 60;
export const OIDC_SCOPE = 'openid offline_access';

export const AUTH_CONFIG_URL = `${API_BASE_URL}/auth-config`;

export const OIDC_REDIRECT_PATH = '/';
